<template>
  <nav class="side">
    <div class="side__inner">
      <div class="top">
        <a href="#">Snowie L</a>
      </div>
      <div class="bottom">
        <a href="https://www.linkedin.com/in/snowieleung">LINKEDIN</a>
        <a href="https://github.com/snowiesuet">GITHUB</a>
        <a href="mailto:snowiesuet@gmail.com">@email</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav"
};
</script>

<style lang="scss">
.side {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: $sideWidth;
  border-right: 1px dashed rgba(black, 0.3);
  color: rgba(black, 0.5);
  font-family: $font-sans;
  text-transform: uppercase;
  letter-spacing: 0.0875rem;
  font-size: 12px;
  transition: $transition;

  &:hover {
    color: rgba(black, 0.5);
  }

  .side__inner {
    position: relative;
    height: 100%;
    white-space: nowrap;
  }

  a {
    margin-right: 10px;
    color: inherit;
    word-spacing: 0;
    transition: $transition;
  }

  .top,
  .bottom {
    position: absolute;
    left: 0;
    transform: rotate(-90deg) perspective(1px);
    transform-origin: $sideWidth $sideWidth;
    height: $sideWidth;
    line-height: $sideWidth;
    white-space: nowrap;
    word-spacing: 0.5rem;
  }

  .top {
    top: $sideWidth * 0.5;
    text-align: right;
    color: black;
  }
  .bottom {
    top: auto;
    bottom: $sideWidth * 1.5;

    &:hover {
      a {
        color: rgba(black, 0.2);

        &:hover {
          color: rgba(black, 0.8);
        }
      }
    }
  }
}
</style>
